import React, { useCallback, useMemo, useState } from 'react';
import Modal from '@mui/material/Modal';
import { TMaterialStyles } from '../../../theme';
import { Grid2 } from '@mui/material';
import { ModalWrapper } from '../../Wrappers/ModalWrapper';
import { useTranslation } from 'react-i18next';
import { ButtonOutlined } from '../../Buttons/ButtonOutlined';
import TypographyWithShadow from '../../Typography/TypographyWithShadow';

export interface IGameRules {
  title: string;
  text: string;
}

interface IRulesModal {
  showRulesModal: boolean;
  setShowRulesModal: (data: boolean) => void;
  rules: IGameRules[];
  startGameHandler?: () => void;
}

export const RulesModal: React.FC<IRulesModal> = ({
  showRulesModal,
  setShowRulesModal,
  rules,
  startGameHandler,
}) => {
  const { t } = useTranslation();
  const [activeRule, setActiveRule] = useState(0);
  const nextBtnText = useMemo(
    () =>
      activeRule === rules.length - 1
        ? startGameHandler
          ? 'start game'
          : t('common.close')
        : t('common.next'),
    [activeRule, rules.length, startGameHandler, t],
  );

  const closeRulesModal = useCallback(() => {
    if (startGameHandler) {
      startGameHandler();
      return;
    }
    setShowRulesModal(false);
    setActiveRule(0);
  }, [setShowRulesModal, startGameHandler]);

  const nextHandler = useCallback(() => {
    if (activeRule < rules.length - 1) {
      setActiveRule((prev) => prev + 1);
    } else {
      startGameHandler ? startGameHandler() : closeRulesModal();
    }
  }, [activeRule, closeRulesModal, rules.length, startGameHandler]);

  const { title, text } = rules[activeRule];

  return (
    <Modal
      open={showRulesModal}
      onClose={closeRulesModal}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
    >
      <ModalWrapper onClose={closeRulesModal}>
        <Grid2 sx={materialStyles.container}>
          <TypographyWithShadow shadowType="DARK" sx={materialStyles.title}>
            {title}
          </TypographyWithShadow>
          <TypographyWithShadow shadowType="DARK" sx={materialStyles.text}>
            {text}
          </TypographyWithShadow>
          <ButtonOutlined
            shadowType="DARK"
            onClick={nextHandler}
            sx={materialStyles.next}
            fontSize={19}
          >
            {nextBtnText}
          </ButtonOutlined>
        </Grid2>
      </ModalWrapper>
    </Modal>
  );
};

const materialStyles: TMaterialStyles = {
  title: {
    fontFamily: 'Rubber Duck !important',
    fontSize: '20px',
    textAlign: 'center',
    letterSpacing: '0.6px',
    mb: '10px',
  },
  text: {
    fontSize: '13px',
    textAlign: 'center',
    letterSpacing: '-0.3px',
    fontWeight: '700',
    mb: '24px',
    lineHeight: '16px',
  },
  container: {
    padding: '46px 30px 17px 30px',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
  },
  next: {
    textTransform: 'uppercase',
    maxWidth: '100%',
    width: '165px',
    height: '41px',
  },
};
